// @ts-nocheck
import React from 'react';
import { Button, Divider } from 'takeat-design-system-ui-kit';
import useWhatsappStore from '~/store/whatsappStore';
import StatusBadge from '~/components/StatusBadge';
import QRArea from '../Components/QRArea';
import AIAssistant from '../Components/AIAssistant';
import {
  WppModalText,
  StyledConnectionCard,
  StyledRowContainer,
  StyledLabel,
  StyledValue,
  QRConnectionAreaContainer,
  WppModalTitle,
} from './styles';

const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  const countryCode = phoneNumber.slice(0, 2);
  const areaCode = phoneNumber.slice(2, 4);
  const firstPart = phoneNumber.slice(4, 9);
  const secondPart = phoneNumber.slice(9);
  return `+${countryCode} ${areaCode} ${firstPart}-${secondPart}`;
};

function ConnectionCard({ connection }) {
  const display = (v) =>
    v === null || v === undefined || v === '' ? '—' : String(v);
  const [refreshing, setRefreshing] = React.useState(false);

  return (
    <StyledConnectionCard>
      <StyledRowContainer>
        <StyledLabel>Código da conexão</StyledLabel>
        <StyledValue style={{ fontSize: '12px' }}>
          {display(connection.instance_name)}
        </StyledValue>
      </StyledRowContainer>
      <Divider />
      <StyledRowContainer>
        <StyledLabel>Telefone conectado</StyledLabel>
        <StyledValue>
          {connection.phone_number
            ? formatPhoneNumber(connection.phone_number)
            : 'Não conectado'}
        </StyledValue>
      </StyledRowContainer>
      <Divider />
      <StyledRowContainer>
        <StyledLabel>Status</StyledLabel>
        <StyledValue
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
            gap: 8,
          }}
        >
          <StatusBadge status={connection.status} />
        </StyledValue>
      </StyledRowContainer>
    </StyledConnectionCard>
  );
}

export default function ConnectionTab({
  phoneDetails,
  wppStatus,
  wppQrcode,
  countdown,
  COUNTDOWN_TIME,
  isValidQrCode,
  loadingQrCode,
  waitingForWebhook,
  createInstance,
  logoutWpp,
  user,
  onOpenAiTab,
}) {
  const { planType } = useWhatsappStore();
  const isConnected = wppStatus === 'open';

  const getButtonText = (status, qrcode) => {
    if (status === 'created' && !qrcode) return 'Gerar novo QR Code';
    if (qrcode) return 'Gerar novo QR Code';
    return 'Iniciar conexão';
  };

  const isConnecting = wppStatus === 'created' || wppStatus === 'connecting';

  if (isConnected) {
    return (
      <div>
        <ConnectionCard connection={{ ...phoneDetails, status: wppStatus }} />
        <AIAssistant
          disabled={planType === 'BASIC_AUTOMATION'}
          onOpenAiTab={onOpenAiTab}
        />
        <div style={{ marginTop: '16px' }} />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            isLoading={loadingQrCode}
            disabled={loadingQrCode}
            onClick={logoutWpp}
            color="red"
            style={{ minWidth: '220px' }}
          >
            Desconectar
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        padding: '2px',
      }}
    >
      <div>
        <ConnectionCard connection={{ ...phoneDetails, status: wppStatus }} />
      </div>
      <AIAssistant
        disabled={planType === 'BASIC_AUTOMATION'}
        onOpenAiTab={onOpenAiTab}
      />
      <QRConnectionAreaContainer>
        <WppModalTitle>
          Siga as instruções para ler o{' '}
          <strong style={{ color: '#2EC9B7' }}>QR Code</strong> e efetivar a
          conexão:
        </WppModalTitle>
        <QRArea
          wppQrcode={wppQrcode}
          countdown={countdown}
          COUNTDOWN_TIME={COUNTDOWN_TIME}
          isValidQrCode={isValidQrCode}
          loadingQrCode={loadingQrCode}
          waitingForWebhook={waitingForWebhook}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '10px',
          }}
        >
          <Button
            onClick={() => createInstance(!!wppQrcode)}
            isLoading={loadingQrCode}
            disabled={loadingQrCode || (wppStatus === 'created' && wppQrcode)}
            style={{ minWidth: '220px' }}
          >
            {getButtonText(wppStatus, wppQrcode)}
          </Button>
        </div>
      </QRConnectionAreaContainer>
    </div>
  );
}
